import React, { useState } from 'react'
import styled, { keyframes } from 'styled-components'
import { RCWidth, base, deepClone, getVisibilityColor } from '../utils'
import Loading from './Loading'
import { useDispatch, useSelector } from 'react-redux'
import { doc, updateDoc } from 'firebase/firestore'
import { db } from '../firebase'
import { redNex } from '../Redux/nexSlice'

function Sitemaps({ nexListn, _nex }) {
    const [data, setData] = useState([])
    const [url, setUrl] = useState('')

    const [isLoading, setIsLoading] = useState(false)

    const [noInput1, setNoInput1] = useState(false)

    const user = useSelector(state=> state.user.user)
    const nx = useSelector(state=> state.nex.nex)

    const dispatch = useDispatch()

    const getData = async () => {
        if(url !== '') {
          setNoInput1(false)

          const updateAnalytics = async () => {
            const tool = window.location.pathname.split('/').pop();
            let tools = deepClone(user.analytics.toolsUsage);
        
            if (isNaN(tools[tool]) || tools[tool] == 'NaN') {
                tools[tool] = 1;
            } else {
                tools[tool] = Number(tools[tool]) + 1;
            }
        
            await updateDoc(doc(db, 'users', user.id), { analytics: { toolsUsage: tools } });
        };


          setIsLoading(true)
            fetch(`${base}/res`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                type: 'sm',
                url: url,
                userId: user.id
              })
            }).then(res=> res.json()).then(data=> {
              setData(data)
              setIsLoading(false)
              dispatch(redNex(nx))
              updateAnalytics()
            })
          } else {
            if(url.trim() === '') setNoInput1(true)
          }
    }


    
  return (
    <SitemapContainer>
        <SitemapInputContainer>
            <h2>Sitemaps</h2>
            <SitemapInputInnerContainer>
                <div style={{position: 'relative', marginBottom: '20px'}}><label style={{position: 'absolute', transform: 'translateY(-70%)', left: '23px', top: '20%', fontSize: 'small'}}>Enter Website</label><input type='url' placeholder='example.com' style={{marginLeft: '20px', borderColor: noInput1? 'red': ''}} value={url} onChange={e=> setUrl(e.target.value)}/></div>
                {nx !== 0 && <button onClick={()=> !isLoading? getData() : ()=> {}} style={isLoading ? {backgroundColor: 'lightgray', color: 'gray', cursor: 'not-allowed'}: {}}>{!isLoading ?'Get Data': 'Getting Data ...'}</button>}
          {nx === 0 && <button style={{backgroundColor: 'lightgray', color: 'red', cursor: 'not-allowed'}}>Insufficient Nexilum units!</button>}
            </SitemapInputInnerContainer>
        </SitemapInputContainer>

        {data?.length !== 0 && !isLoading && <SitemapResContainer>
                    <SmContainer>
                        <p style={{marginLeft: '20px', width: '400px', fontSize: 'medium', fontWeight: '400'}}>URL</p>
                        <p style={{marginLeft: 'auto', width: '50px', fontSize: 'medium', fontWeight: '400', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>Status</p>
                        <p style={{marginLeft: '20px', width: '150px', fontSize: 'medium', fontWeight: '400', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>Type</p>
                        <p style={{marginLeft: '20px', width: '50px', fontSize: 'medium', fontWeight: '400', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>Entries</p>
                        <p style={{marginLeft: '20px', width: '50px', fontSize: 'medium', fontWeight: '400', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>Visibility</p>
                    </SmContainer>
            {data?.map(s=> {
                return (
                    <SmContainer>
                        <p style={{marginLeft: '20px', width: '400px', fontSize: 'medium'}}>{s.url}</p>
                        <p style={{marginLeft: 'auto', width: '50px', fontSize: 'medium', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>{s.status}</p>
                        <p style={{marginLeft: '20px', width: '150px', fontSize: 'medium', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>{s.type}</p>
                        <p style={{marginLeft: '20px', width: '50px', fontSize: 'medium', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>{s.entries}</p>
                        <p style={{marginLeft: '20px', width: '50px', fontSize: 'medium', display: 'flex', justifyContent: 'center', alignItems: 'center', color: getVisibilityColor(s.visibility)}}>{s.visibility}</p>
                    </SmContainer>
                )
            })}
        </SitemapResContainer>}
        {isLoading && <Loading />}

        {data.length == 0 && !isLoading && <Intro>

          <h3>Tool Overview</h3>
  <br />
  <p>
    The Sitemaps Tool displays the URL of your website’s sitemap and its visibility status to search engines. 
    Use this tool to ensure that your sitemap is properly accessible and indexed by search engines, which helps improve your site's visibility and SEO.
  </p>
  <br /><br />
  
  <h3>Instructions</h3>
  <br />
  <p>1. Enter your website URL to retrieve the sitemap URL and its visibility status</p>
  <p>2. Click "Get Data" to view the sitemap URL and its current visibility to search engines</p>
  <br /><br />
  
  <h3>Tips</h3>
  <br />
  <p>Verify that your sitemap is accessible and properly indexed by search engines to ensure all important pages are included in search results</p>

        </Intro>}
    </SitemapContainer>
  )
}

export default Sitemaps


const SitemapContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: ${RCWidth};
`

const fadeInAnimation = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`


const SitemapInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 3px;
  box-shadow: 2px 2px 16px -8px rgb(239, 239, 239);
  background-color: white;
  margin-inline: 20px;
  padding: 20px;
  margin-top: 25px;
  z-index: 2;

  > h2 {
    font-weight: 100;
    margin-bottom: 20px;
  }

  > div > input {
    outline: none;
    border-radius: 2px;
    width: 200px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    color: var(--se-color);
  }

  > div > input::placeholder {
    color: rgba(180, 180, 180);
  }

  > div > .select-country {
    outline: none;
    border-radius: 2px;
    width: 200px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    margin-left: 20px;
    color: var(--se-color);
  }

  > div > button {
    border: none;
    border-radius: 2px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    padding: 5px;
    margin-left: 60px;
    cursor: pointer;
    background-color: var(--se-color);
    color: white;
  }

  > div > button:hover {
    color: var(--se-color);
    background-color: rgb(239, 239, 239);
  }
`

const SitemapInputInnerContainer = styled.div`
  display: flex;
  margin-top: 20px;

  > div > input {
    outline: none;
    border-radius: 2px;
    width: 200px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    color: var(--se-color);
    padding-left: 100px;
    font-size: medium;
  }

  > div > input::placeholder {
    color: rgba(180, 180, 180);
  }
`


const SitemapResContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  margin: 20px;
  overflow-x: hidden;
  overflow-y: hidden;
  background-color: white;
  border-radius: 2px;
  z-index: 2;
  margin-bottom: 70px;
  padding-bottom: 10px;
`


const SmContainer = styled.div`
    display: flex;
    flex-direction: row;
    padding: 10px;
    margin-block: 5px;
    border-bottom: 1px solid rgb(230, 230, 230);
`


const Intro = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px 20px 20px 20px;

  opacity: 0;
  animation: ${fadeInAnimation} 0.3s ease-in-out forwards;

  > h3 {
    color: white;
    font-family: 'Quicksand';
    font-weight: 500;
  }

  > p {
    color: white;
    font-family: 'Quicksand';
    width: 60%;
  }
`